var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAFlagChile24 = function SvgAFlagChile24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 18H0V0H24V18Z",
    fill: "#D52B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33333H24V0H0L8 9.33333Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.33333H24V0H0L8 9.33333Z",
    fill: "#FAFAFA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 9.33333H0V0H9.33333V9.33333Z",
    fill: "#0039A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 3.86064L3.90284 4.80515L3.43101 6.33334L4.6665 5.38883L5.902 6.33334L5.43017 4.80515L6.6665 3.86064H5.13833L4.6665 2.33334L4.19468 3.86064H2.6665Z",
    fill: "white"
  })));
};
export { SvgAFlagChile24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTI0IDE4SDBWMEgyNFYxOFoiIGZpbGw9IiNENTJCMUUiLz4KPHBhdGggZD0iTTggOS4zMzMzM0gyNFYwSDBMOCA5LjMzMzMzWiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTggOS4zMzMzM0gyNFYwSDBMOCA5LjMzMzMzWiIgZmlsbD0iI0ZBRkFGQSIvPgo8cGF0aCBkPSJNOS4zMzMzMyA5LjMzMzMzSDBWMEg5LjMzMzMzVjkuMzMzMzNaIiBmaWxsPSIjMDAzOUE2Ii8+CjxwYXRoIGQ9Ik0yLjY2NjUgMy44NjA2NEwzLjkwMjg0IDQuODA1MTVMMy40MzEwMSA2LjMzMzM0TDQuNjY2NSA1LjM4ODgzTDUuOTAyIDYuMzMzMzRMNS40MzAxNyA0LjgwNTE1TDYuNjY2NSAzLjg2MDY0SDUuMTM4MzNMNC42NjY1IDIuMzMzMzRMNC4xOTQ2OCAzLjg2MDY0SDIuNjY2NVoiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";